let lexicon = {
  ru: {
    main_button: "Получить быстрый расчёт",
    description:
      "Заполните поля ниже и менеджер перезвонит Вам с точным расчетом стоимости",

    input_material: "Материал",
    input_volume: "Объем",
    input_address: "Укажите адрес доставки",

    result_material: "Материал",
    result_volume: "Объем",
    result_address: "Адрес доставки",
  },
};

export default lexicon;
